import { ComponentBread, ComponentHeader, StyledCreate } from "@components";
import { AdminForm } from "@modules";
import { useAdminDetail } from "@utils";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

const data = [
  {
    title: <a href={"/admins"}>Admins</a>,
  },
  {
    title: <a href={"/add-admin"}>Add Admin</a>,
  },
];

export const PageCreateAdmin = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const { data: admin } = useAdminDetail(id);

  return (
    <>
      <ComponentHeader title={t("page.admin_user")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <AdminForm admin={admin} />
      </StyledCreate>
    </>
  );
};
